import { AlertCard } from "@dash/page";
import { useTheme } from "@emotion/react";
import { MdWarningAmber } from "react-icons/md";
import { Link } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";
import { Uuid } from "@megaron/uuid";

import { Customer } from "./OrderDraftPageContent";

type Props = {
  customer: Customer;
};

export const CustomerAlert = ({ customer }: Props) => {
  return (
    <Link to={customer.uuid ? getMegaraxPath.uri("megarax://crm/customers/id/{id}", { id: Uuid(customer.uuid) }) : ""}>
      <AlertCard title={customer.name}>{customer.alert}</AlertCard>
    </Link>
  );
};
